import {
  ArchiveTeamCoachCommand,
  IArchiveTeamCoachCommand,
  IInviteCoachCommand,
  IJoinTeamCommand,
  IResendCoachInviteCommand,
  InviteCoachCommand,
  JoinTeamCommand,
  ResendCoachInviteCommand,
  TeamCoachStatus,
  UserInviteStatus,
} from "@growth-machine-llc/stridist-api-client";
import { teamClient } from "../api/ApiClients";
import ServiceBase from "./ServiceBase";

class TeamService extends ServiceBase {
  async getCoaches(status: TeamCoachStatus = TeamCoachStatus.Active) {
    return teamClient.getCoaches(status);
  }

  async getInvitedCoaches() {
    return teamClient.getInvitedCoaches();
  }
  async getPendingCoachesCount(): Promise<number> {
    return teamClient.getPendingCoachesCount();
  }

  async inviteCoach(data: IInviteCoachCommand) {
    const command = new InviteCoachCommand(data);
    return teamClient.inviteCoach(command);
  }

  async getInvitedWorkspace(
    fbUserId: string,
    workspaceSlug: string,
    email: string,
  ) {
    return teamClient.getInvitedWorkspace(fbUserId, workspaceSlug, email);
  }

  async resendCoachInvite(data: IResendCoachInviteCommand) {
    const command = new ResendCoachInviteCommand(data);
    return teamClient.resendCoachInvite(command);
  }

  async revokeCoachInvite(id: number) {
    return teamClient.revokeCoachInvite(id);
  }

  async joinTeam(data: IJoinTeamCommand) {
    const command = new JoinTeamCommand(data);
    return teamClient.joinTeam(command);
  }

  async archiveCoach(data: IArchiveTeamCoachCommand) {
    const command = new ArchiveTeamCoachCommand(data);
    return teamClient.archiveTeamCoach(command);
  }

  async getGroupCoachesAndClients(
    page: number,
    pageSize: number,
    groupId?: number,
    searchQuery?: string,
  ) {
    return teamClient.getGroupCoachesAndClientsWithPagination(
      page,
      pageSize,
      groupId,
      searchQuery,
    );
  }
}

export default new TeamService();
